<template>
	<div class="add-tag-input">
		<template v-if="!iconOff">
			<ui-input
				v-model="string"
				:size="size"
				:groupicon="icon"
				design="br-off"
				:placeholder="placeholder"
				invertgroup
			/>
		</template>
		<template v-else>
			<ui-input v-model="string" :size="size" :placeholder="placeholder" />
		</template>

		<ui-button
			design="success tg-button b-rl-off"
			:class="buttonClass"
			:disabled="hasInputText"
			@click="doAction"
			>{{ buttonText }}</ui-button
		>
	</div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'

	export default {
		name: 'ui-add-tag-input',

		components: {
			uiButton,
			uiInput
		},

		props: {
			buttonText: {
				type: String,
				default: 'Adicionar'
			},

			buttonAction: {
				type: Function
			},

			icon: {
				type: String,
				default: 'fal fa-tags'
			},

			iconOff: {
				type: Boolean,
				default: false
			},

			size: {
				type: String,
				default: 'lg'
			},

			placeholder: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				string: ''
			}
		},

		computed: {
			hasInputText() {
				return !this.string
			},

			buttonClass() {
				return {
					[this.size]: true
				}
			}
		},

		methods: {
			doAction() {
				this.buttonAction(this.string)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
